import { render, staticRenderFns } from "./ReportingChannel.vue?vue&type=template&id=91ef3a0a&"
import script from "./ReportingChannel.vue?vue&type=script&lang=js&"
export * from "./ReportingChannel.vue?vue&type=script&lang=js&"
import style0 from "./ReportingChannel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91ef3a0a')) {
      api.createRecord('91ef3a0a', component.options)
    } else {
      api.reload('91ef3a0a', component.options)
    }
    module.hot.accept("./ReportingChannel.vue?vue&type=template&id=91ef3a0a&", function () {
      api.rerender('91ef3a0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/legal_entities/tabs/ReportingChannel.vue"
export default component.exports